import { getCookie, setCookie } from "../cookies/cookieMgr"
import { validValue } from "@/utils/validUtils"

const reCalcProduct = (state) => {
    let order_incl_gst = 0
    state.products.forEach((element) => {
        let is_credit = (element.is_credit ?? 0)
        element.unit_qty = element.qty
        element.order_qty = element.qty
        if (is_credit > 0) {
            // 充值商品处理
            element.retail = 0
            element.incl_gst = 0
            element.gst = 0
            element.subtotal = 0
        } else {
            // element.unit_retail = element.retail * 0.9
            // element.retail = element.unit_retail * 0.9
            // 普通商品处理
            element.incl_gst = element.qty * element.retail
            element.gst = element.incl_gst * 0.15
            element.subtotal = element.incl_gst - element.gst
            order_incl_gst += element.incl_gst
        }
    })
    state.order_incl_gst = order_incl_gst
    state.gst = order_incl_gst * 0.15
    state.subtotal = order_incl_gst - state.gst
    // console.log(state.products)
    console.log("reCalcProduct")
    saveCart(state)
}

const loadingCart = (state) => {
    if (state.products.length === 0) {
        let productsJson = getCookie("products")
        let productsData = productsJson ? JSON.parse(productsJson) : []
        if (productsData && productsData.length > 0) {
            state.products = productsData
        }
    }
    if (validValue(state.shippingMethod)) {
        let shippingMethod = getCookie("shippingMethod")
        if (validValue(shippingMethod)) {
            state.shippingMethod = shippingMethod
        }
    }
    if (validValue(state.pickupDate)) {
        let pickupDate = getCookie("pickupDate")
        if (validValue(pickupDate)) {
            state.pickupDate = pickupDate
        }
    }
    if (validValue(state.branchID)) {
        let branchID = getCookie("branchID")
        if (validValue(branchID)) {
            state.branchID = branchID
        }
    }
    if (validValue(state.kidsID)) {
        let kidsID = getCookie("kidsID")
        if (validValue(kidsID)) {
            state.kidsID = kidsID
        }
    }
    if (validValue(state.paymentMethod)) {
        let paymentMethod = getCookie("paymentMethod")
        if (validValue(paymentMethod)) {
            state.paymentMethod = paymentMethod
        }
    }
    if (validValue(state.deliveryFee)) {
        let deliveryFee = getCookie("deliveryFee")
        if (validValue(deliveryFee)) {
            state.deliveryFee = deliveryFee
        } else {
            state.deliveryFee = 0
        }
    }
    if (validValue(state.order_incl_gst)) {
        let order_incl_gst = getCookie("order_incl_gst")
        if (validValue(order_incl_gst)) {
            state.order_incl_gst = order_incl_gst
        } else {
            state.order_incl_gst = 0
        }
    }
    if (validValue(state.gst)) {
        let gst = getCookie("order_gst")
        if (validValue(gst)) {
            state.gst = gst
        } else {
            state.gst = 0
        }
    }
    if (validValue(state.subtotal)) {
        let subtotal = getCookie("order_subtotal")
        if (validValue(subtotal)) {
            state.subtotal = subtotal
        } else {
            state.subtotal = 0
        }
    }
    if (validValue(state.order_id)) {
        let orderId = getCookie("order_id")
        if (validValue(orderId)) {
            state.order_id = orderId
        } else {
            state.order_id = 0
        }
    }
    if (validValue(state.order_note)) {
        let order_note = getCookie("order_note")
        if (validValue(order_note)) {
            state.order_note = order_note
        } else {
            state.order_note = ""
        }
    }
    if (validValue(state.isTopup)) {
        let isTopup = getCookie("isTopup")
        if (validValue(isTopup)) {
            state.isTopup = isTopup
        } else {
            state.isTopup = 0
        }
    }
}

const saveCart = (state) => {
    setCookie("products", JSON.stringify(state.products))
    setCookie("deliveryFee", state.deliveryFee)
    setCookie("shippingMethod", state.shippingMethod)
    setCookie("pickupDate", state.pickupDate)
    setCookie("branchID", state.branchID)
    setCookie("kidsID", state.kidsID)
    setCookie("paymentMethod", state.paymentMethod)
    setCookie("order_incl_gst", state.order_incl_gst)
    setCookie("order_gst", state.gst)
    setCookie("order_subtotal", state.subtotal)
    setCookie("order_id", state.order_id)
    setCookie("order_note", state.order_note)
    setCookie("isTopup", state.isTopup)
}

const cartStore = {
    state: {
        products      : [],
        deliveryFee   : 0,    // 配送费
        shippingMethod  : "",   // 取货方式
        pickupDate    : "",   // 取货时间
        branchID      : 0,    // 取货门店
        kidsID        : 0,    // 儿童ID
        paymentMethod : "",   // 支付方式
        order_incl_gst: 0,    // 订单总额
        order_gst     : 0,    // 订单税金
        order_subtotal: 0,    // 订单小计
        order_id      : 0,    // 订单ID
        order_note    : "",   // 备注
        isTopup       : 0     // 是否是topup
    },
    getters: {
        getCartAll: (state) => {
            return state
        },
        getCartProducts: (state) => {
            loadingCart(state)
            return state.products
        },
        getCartQty: (state) => {
            loadingCart(state)
            if (state.products && state.products.length > 0) {
                let qty = 0
                state.products.forEach((element) => {
                    qty += element.qty
                })
                return qty
            }
            return 0
        },
        getCartItemCount: (state) => {
            loadingCart(state)
            return state.products.length
        },
        getCartTotal: (state) => {
            loadingCart(state)
            var total = 0
            state.products.forEach((element) => {
                total += element.qty * element.retail
            })
            return total * 100
        },
        getShippingMethod: (state) => {
            return state.shippingMethod
        },
        getPickupDate: (state) => {
            return state.pickupDate
        },
        getBranchID: (state) => {
            return state.branchID
        },
        getPaymentMethod: (state) => {
            return state.paymentMethod
        },
        getKidsID: (state) => {
            return state.kidsID
        },
        getDeliveryFee: (state) => {
            return state.deliveryFee
        },
        getOrderInclGST: (state) => {
            return state.order_incl_gst
        },
        getOrderGST: (state) => {
            return state.gst
        },
        getOrderSubtotal: (state) => {
            return state.subtotal
        },
        getOrderId: (state) => {
            return state.order_id
        },
        getOrderNote: (state) => {
            return state.order_note
        },
        getIsTopup: (state) => {
            let isTopup = parseInt(state.isTopup)
            return isTopup
        }
    },
    mutations: {
        addProductToCart(state, product) {
            let isFind = false
            state.products.forEach((element) => {
                if (element.uniqueId === product.uniqueId) {
                    isFind = true
                    element.qty++
                    return
                }
            })
            if (isFind === false) {
                product["qty"] = 1
                state.products.push(product)
            }
            reCalcProduct(state)
        },
        removeProductFromCart(state, product) {
            state.products.splice(state.products.indexOf(product), 1)
            if (state.products.length === 0) {
                state.products = []
            }
            reCalcProduct(state)
        },
        updateProductQty(state, params) {
            let product = params.product
            let qty = params.qty
            state.products[state.products.indexOf(product)].qty = qty
            // remove product if qty is 0
            if (qty === 0) {
                state.products.splice(state.products.indexOf(product), 1)
            }
            reCalcProduct(state)
        },
        cartCalc(state) {
            reCalcProduct(state)
            saveCart(state)
        },
        clearCart(state) {
            state.products = []
            state.deliveryFee = 0
            state.shippingMethod = ""
            state.pickupDate = ""
            state.branchID = 0
            state.kidsID = 0
            state.paymentMethod = ""
            state.order_incl_gst = 0
            state.order_gst = 0
            state.order_subtotal = 0
            state.order_id = 0
            state.order_note = ""
            state.isTopup = 0
            saveCart(state)
        },
        setShippingMethod(state, method) {
            state.shippingMethod = method
            reCalcProduct(state)
            saveCart(state)
        },
        setPickupDate(state, date) {
            state.pickupDate = date
            reCalcProduct(state)
            saveCart(state)
        },
        setBranchID(state, id) {
            state.branchID = id
            reCalcProduct(state)
            saveCart(state)
        },
        setKidsID(state, id) {
            state.kidsID = id
            reCalcProduct(state)
            saveCart(state)
        },
        setPaymentMethod(state, method) {
            state.paymentMethod = method
            reCalcProduct(state)
            saveCart(state)
        },
        setOrderId(state, id) {
            state.order_id = id
            saveCart(state)
        },
        setOrderNote(state, order_note) {
            state.order_note = order_note
            saveCart(state)
        },
        setIsTopup(state, isTopup) {
            state.isTopup = isTopup
            saveCart(state)
        }
    },
}

export default cartStore
